import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

/** Laufzeit-Umgebung, allein aus dem Hostname abgeleitet. */
export type Umgebung = 'live' | 'test' | 'dev';

export interface UmgebungsKennzeichen {
  /** Text im Warnbanner. */
  kuerzel: string;
  /** Steuert die Farbgebung des Banners. */
  variante: 'test' | 'dev';
}

const HOST_LIVE = 'app.planaudit.de';
const HOST_TEST = 'app.test.planaudit.de';

const KENNZEICHEN: Record<Umgebung, UmgebungsKennzeichen | null> = {
  live: null,
  test: { kuerzel: 'TESTUMGEBUNG', variante: 'test' },
  dev: { kuerzel: 'ENTWICKLUNGSUMGEBUNG', variante: 'dev' },
};

const TITEL_PRAEFIX: Record<Umgebung, string> = {
  live: '',
  test: '[TEST] ',
  dev: '[DEV] ',
};

/**
 * Erkennt die laufende Umgebung am Hostname des Browsers.
 *
 * Whitelist-Live: Nur der exakte Live-Hostname gilt als Live, jeder unbekannte
 * Host als Dev. Dadurch kann eine neue oder vergessene Umgebung nie fälschlich
 * für Live gehalten werden — sie sieht schlimmstenfalls wie Dev aus.
 *
 * Der Vergleich ist bewusst eine Gleichheitsprüfung: `endsWith('planaudit.de')`
 * würde `app.planaudit.de.beispiel.com` als Live durchgehen lassen.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private readonly document = inject(DOCUMENT);

  readonly umgebung: Umgebung;
  readonly kennzeichen: UmgebungsKennzeichen | null;
  readonly titelPraefix: string;

  constructor() {
    const hostname = (this.document.location?.hostname ?? '').toLowerCase();
    this.umgebung = hostname === HOST_LIVE ? 'live' : hostname === HOST_TEST ? 'test' : 'dev';
    this.kennzeichen = KENNZEICHEN[this.umgebung];
    this.titelPraefix = TITEL_PRAEFIX[this.umgebung];
  }
}
